<template>
    <div class="wrapper">
        <div class="animated fadeIn">
            <b-row>
                <b-col>
                    <b-card header="Nieuw bestuurslid toevoegen">
                        <b-form @submit.prevent="createUser">
                            <b-row>
                                <b-col cols="12" md="6">
                                    <b-form-group label="Naam">
                                        <b-form-input type="text" required v-model="user.name"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" md="6">
                                    <b-form-group label="E-mail">
                                        <b-form-input type="email" required v-model="user.email"></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="12" md="6">
                                    <b-form-group label="Type account">
                                        <b-form-select v-model="user.type" :options="selectOptions"></b-form-select>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="12" md="6">
                                    <b-form-group label="Wachtwoord">
                                        <b-form-input type="password" v-model="user.password" required />
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" md="6">
                                    <b-form-group label="Wachtwoord bevestiging">
                                        <b-form-input type="password" v-model="user.password_confirmation" required />
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="12">
                                    <hr>
                                    <b-button type="submit" variant="success" class="pull-right">Toevoegen</b-button>
                                </b-col>
                            </b-row>
                        </b-form>
                    </b-card>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
    import {storeData} from "../../api";

    export default {
        name: 'user-new',
        data () {
            return {
                user: {
                    name: null,
                    email: null,
                    type: 'admin',
                    password: undefined,
                    password_confirmation: undefined,
                },
                selectOptions: [
                    { value: 'admin', text: 'Admin' },
                    { value: 'super-admin', text: 'Super Admin' },
                ]
            }
        },
        methods: {
            createUser() {

                storeData(`users`, this.user)
                    .then(({data}) => {
                        this.$router.push({name: 'users.view', params: {id: data.data.id}})
                    });
            }
        }
    }
</script>
